<template>
<div class="consent" v-if="showComponent">
  <h3 v-if="label !== null ">{{label}}</h3>
  <div class="consent__policy-text">
    <p>Nissan would like to keep you updated on their latest products, services, promotions and offers.</p>
    <br/>
    <p>I am happy to receive marketing communication from Nissan (Nissan Motor (GB) Limited and Nissan Automotive Europe S.A.S) by (please tick the relevant boxes below):</p>
    <br/>
    <p>You may change your preferences or stop receiving marketing communications at any time by using the unsubscribe link in the communications sent to you or by clicking <a title="Marketing preferences" href="https://www.nissan.co.uk/manage-your-preferences.html" target="_blank" rel="noopener">here</a>.</p>
    <br/>
    <p>To find out more about how Nissan use your personal data, you can visit their <a title="Privacy Policy" href="https://www.nissan.co.uk/gdpr.html" target="_blank" rel="noopener">Privacy Policy</a>.</p>
  </div>
  <div class="consent__options-container" :class="{ 'consent__options-container--last': isLast }">
    <div class="consent__preference consent__preference--pre">
      <div class="consent__options">
        <label class="consent__label" :for="`${policyTypeName}-OptInEmail`">Email</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInEmail`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInEmail" @change="updateConsentOption('OptInEmail', optInData.OptInEmail)" :id="`${policyTypeName}-OptInEmail`"/>
            <div class="tla-check__indicator"></div>
          </label>
        </div>
      </div>
      <div class="consent__options">
        <label class="consent__label" :for="`${policyTypeName}-OptInPhone`">Phone</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInPhone`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInPhone" @change="updateConsentOption('OptInPhone', optInData.OptInPhone)" :id="`${policyTypeName}-OptInPhone`"/>
            <div class="tla-check__indicator"></div>
          </label>
        </div>
      </div>
      <div class="consent__options">
        <label class="consent__label" :for="`${policyTypeName}-OptInSms`">SMS</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInSms`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInSms" @change="updateConsentOption('OptInSms', optInData.OptInSms)" :id="`${policyTypeName}-OptInSms`"/>
            <div class="tla-check__indicator"></div>
          </label>
        </div>
      </div>
      <div class="consent__options consent__options--last">
        <label class="consent__label" :for="`${policyTypeName}-OptInPost`">Post</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInPost`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInPost" @change="updateConsentOption('OptInPost', optInData.OptInPost)" :id="`${policyTypeName}-OptInPost`"/>
            <div class="tla-check__indicator"></div>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import {
  namespace
} from 'vuex-class';
import { policyService } from '@/services/PolicyService';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import ToggleSwitchComponent from '../ui/ToggleSwitchComponent.vue';
import OptInData from '../../models/OptInData';

const EnquiryModule = namespace('enquiryModule');

@Component({
  components: {
  'toggle-switch': ToggleSwitchComponent
  }
  })
export default class NissanPresubMultiConsentComponent extends Vue {
  @EnquiryModule.Action public submitOptInConsent;

  @Prop({ default: false })
  public isLast!: boolean;

  @Prop({ default: null })
  public label!: string;

  private optInData: OptInData = new OptInData();

  private consentAll: boolean = false;

  public updateConsentOption(consentOption: string, value: boolean) {
    if (consentOption === 'OptInAll') {
      this.optInData.OptInEmail = value;
      this.optInData.OptInPhone = value;
      this.optInData.OptInSms = value;
      this.optInData.OptInPost = value;
    }

    if (
      (consentOption === 'OptInEmail'
        || consentOption === 'OptInPhone'
        || consentOption === 'OptInSms'
        || consentOption === 'OptInPost')
      && value === false
    ) {
      this.consentAll = false;
    }

    if (this.optInData.OptInEmail
        && this.optInData.OptInPost
        && this.optInData.OptInPhone
        && this.optInData.OptInSms) {
      this.consentAll = true;
    }

    this.submitOptInConsent(this.optInData);
  }

  public get policyTypeName(): string {
    return 'policy-partner-nissan';
  }

  public get currentManufacturerId(): number {
    return this.$store.getters['vehicleModule/currentManufacturerId'];
  }

  public get showComponent(): boolean {
    if ((this.currentManufacturerId === 37 || this.currentManufacturerId === 124)
      && this.optInData.PublishedPolicyId.length > 0) {
      return true;
    }

    return false;
  }

  @Watch('currentManufacturerId')
  public setDefaultConsent() {
    if (this.showComponent) {
      this.submitOptInConsent(this.optInData);
    }
  }

  public created() {
    this.optInData.PolicyType = 3;

    if (policyService.isAskAPrice) {
      this.optInData.PublishedPolicyId = 'b6fd3912-a750-4ee5-b275-ce3b665e8a29';
    } else if (policyService.isCarKeys) {
      this.optInData.PublishedPolicyId = '4b34a6d4-2dd5-408a-a783-509a956250e3';
    } else if (policyService.isGreenCar) {
      this.optInData.PublishedPolicyId = '0942b4d8-7465-493d-a3b7-81b2e8e39bc5';
    } else if (policyService.isVanGuide) {
      this.optInData.PublishedPolicyId = '7f118a21-6d1d-461f-8123-4029cf690951';
    }

    this.setDefaultConsent();
  }
}
</script>
